import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
  optional?: boolean;
  helperText?: string;
  showWordCount?: boolean;
  maxWords?: number;
  currentWords?: number;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ 
    label, 
    error, 
    helperText, 
    optional, 
    showWordCount,
    maxWords,
    currentWords,
    className = '', 
    fullWidth = false, 
    ...props 
  }, ref) => {
    return (
      <div className={`space-y-1.5 ${fullWidth ? 'w-full' : ''}`}>
        {label && (
          <div className="flex items-center justify-between">
            <label className="text-sm font-medium text-slate-700">
              {label}
            </label>
            {optional && <span className="text-xs text-slate-400">Optional</span>}
          </div>
        )}
        <textarea
          ref={ref}
          className={`px-3 py-2.5 text-sm text-slate-900 border border-slate-200 rounded-lg 
            focus:outline-none focus:ring-2 focus:ring-slate-900/10 focus:border-slate-400 
            disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed
            resize-none transition-shadow ${fullWidth ? 'w-full' : ''} ${className}`}
          {...props}
        />
        {showWordCount && maxWords && currentWords !== undefined && (
          <div className="text-xs text-slate-400 text-right">
            {currentWords} / {maxWords} words
          </div>
        )}
        {helperText && !error && (
          <p className="text-xs text-slate-500">{helperText}</p>
        )}
        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;

